import { Filter } from '@/models/Filter';
import L from 'leaflet';

export interface ISavedFilter {
    MFID: number;
    Notifications: boolean;
    Name: string;
    Filter: Filter;
    Polygon: L.Polygon | L.LatLngExpression[] | null;
    MultiPolygon: any | null;
}

export class SavedFilter implements ISavedFilter {
    public MFID: number;
    public Notifications: boolean;
    public Name: string;
    public Filter: Filter;
    public Polygon: L.Polygon | L.LatLngExpression[] | null;
    public MultiPolygon: any | null;
    constructor(
        savedFilterProps: any,
    ) {
        this.MFID = savedFilterProps.MFID;
        this.Notifications = savedFilterProps.Notifications;
        this.Name = savedFilterProps.Name;
        this.Filter = new Filter(savedFilterProps.Filter);
        this.Polygon = savedFilterProps.Polygon;
        this.MultiPolygon = savedFilterProps.MultiPolygon;
    }
    public toJson() {
        return {
            mdid: this.MFID,
            notifications: this.Notifications,
            name: this.Name,
            filter: this.Filter.toJson(),
            polygon: this.Polygon,
            multipolygon: this.MultiPolygon,
        };
    }
    public getGeoJson() {
        if (this.Polygon) {
            // @ts-ignore
            return L.polygon(this.Polygon).toGeoJSON();
        }
        return null;
    }
}

